import {
  FetchProductCacheKey,
  FetchProductGqlQuery,
  ProductID,
  ProductNanoID,
  ProductUUID
} from '../../productsTypes';
import { FetchCacheItemSources, FetchItemGqlQuery } from '../../../../types';

import { useCacheShowQuery } from '../../../common/reactQuery/hooks/useCacheShowQuery';

import { ProductsPermissions } from '../../productsConstants';

interface CacheProductFields {
  uuid: ProductUUID;
}

interface CacheProductResponse<ItemType extends CacheProductFields> {
  product: ItemType | null;
}

interface CacheProductOptions {
  cacheKey: FetchProductCacheKey;
  cacheQuery?: FetchItemGqlQuery;
  options?: {
    cacheTime?: number;
    enabled?: boolean;
    enabledPlaceholder?: boolean;
  };
  productNanoId: ProductNanoID | ProductID;
  query: FetchProductGqlQuery;
  source?: FetchCacheItemSources;
}

const itemKey = 'product';

function useCacheProduct<ItemType extends CacheProductFields>({
  cacheKey,
  cacheQuery,
  options = {},
  productNanoId,
  query,
  source
}: CacheProductOptions) {
  const {
    item,
    itemError,
    itemErrorData,
    itemFetched,
    itemLoading,
    itemIsPlaceholderData,
    updateCacheShowQueryItemCache
  } = useCacheShowQuery<CacheProductResponse<ItemType>, ItemType>({
    action: ProductsPermissions.READ_PRODUCT_SHOW_ES_QUERY,
    cacheKey,
    cacheQuery,
    itemKey,
    options,
    query,
    source,
    uuid: productNanoId
  });

  return {
    product: item,
    productErrorData: itemErrorData,
    productError: itemError,
    productFetched: itemFetched,
    productLoading: itemLoading,
    productIsPlaceholderData: itemIsPlaceholderData,
    updateProductCache: updateCacheShowQueryItemCache
  };
}

export default useCacheProduct;
